/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { CommunicationDto } from '../../models/communication-dto';

export interface GetCommunicationsByEntity$Params {
  entityType: 'ContactPerson' | 'Customer';
  entityId: number;
}

export function getCommunicationsByEntity(http: HttpClient, rootUrl: string, params: GetCommunicationsByEntity$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<CommunicationDto>>> {
  const rb = new RequestBuilder(rootUrl, getCommunicationsByEntity.PATH, 'get');
  if (params) {
    rb.path('entityType', params.entityType, {});
    rb.path('entityId', params.entityId, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<Array<CommunicationDto>>;
    })
  );
}

getCommunicationsByEntity.PATH = '/communications/{entityType}/{entityId}';
